import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Posts from "./Posts";

import './styles.css';

export default class ArtigosBlog extends Component {
    render() {
        return (
            <section>
                <div id="torres-blog">
                    <div className="container">
                        <h2>
                            <Link
                                to={{pathname: "https://www.blogtorresdemeloneto.com.br/"}}
                                rel="noopener noreferrer"
                                target="_blank"> 
                                Blog da Torres de Melo Neto
                            </Link>
                        </h2>
                        <div className="artigos-blog">
                            <Posts />
                        </div>
                    </div>
                </div>
            </section>
        );            
    }
}